export default [
    {
        path: 'erpsaude-relatorio-atendimento',
        component: () => import(
            /* webpackChunkName: 'integracao-erpsaude-relatorio-atendimento' */
            '@/views/integracao/erpsaude/relatorio-atendimento/Index'
        ),
        redirect: 'erpsaude-relatorio-atendimento/index',
        children: [
            {
                name: 'integracao-erpsaude-relatorio-atendimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'integracao-erpsaude-relatorio-atendimento' */
                    '@/views/integracao/erpsaude/relatorio-atendimento/List.vue'
                ),
            },
        ],
    },
]